import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './ExternalPage.css';
import { trackPageView } from '../lib/supabase';
import { findItem, backLinkFor, resolveLink } from '../lib/menuTree';
import LoadingScreen from './LoadingScreen';
import TopBar from './TopBar';

const LINK_MESSAGES = [
  "Getting things ready for you...",
  "Warming up the engines...",
  "Almost there, hang tight!",
  "Loading something fun...",
  "Setting the stage...",
  "Just a few more seconds...",
  "Polishing things up...",
  "Good things take a moment...",
  "Nearly ready to go!",
  "Making sure everything is perfect...",
];

const ARCHIVE_MESSAGES = [
  "Loading from the Internet Archive…",
  "Retrieving your video…",
  "Almost there, hang tight!",
  "Good things take a moment…",
  "Nearly ready to go!",
];

/**
 * A menu item shown full screen in an iframe.
 * kind="external": the item's link (a URL, or per-facility URLs).
 * kind="archive-video": the item's link is an archive.org identifier, shown in
 * archive.org's embeddable player.
 */
export default function ExternalPage({ data, kind = 'external' }) {
  const params = useParams();
  const { categoryId, subcategoryId } = params;
  const isArchive = kind === 'archive-video';

  const item = findItem(data, params);
  const title = item?.name;
  const src = isArchive
    ? `https://archive.org/embed/${item?.link ?? ''}`
    : resolveLink(item?.link, sessionStorage.getItem('initialQueryParamKey'));

  const [isLoading, setIsLoading] = useState(true);

  // Each new piece of content shows the loading screen and records one page view
  useEffect(() => {
    if (!item?.link) return;
    setIsLoading(true);
    trackPageView(title, parseInt(categoryId, 10), subcategoryId ? parseInt(subcategoryId, 10) : null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  if (!item) return <div style={{ padding: '2rem' }}>Content not found</div>;

  return (
    <>
      <TopBar backTo={backLinkFor(params)} title={title} />
      <div className="external-page">
        {isLoading && <LoadingScreen title={title} messages={isArchive ? ARCHIVE_MESSAGES : LINK_MESSAGES} />}
        <iframe
          src={src}
          title={isArchive ? title : 'External Content'}
          className="iframe-content"
          allow={isArchive ? 'autoplay; fullscreen *' : undefined}
          onLoad={() => setIsLoading(false)}
        />
      </div>
    </>
  );
}
